<script>
    import Average from "./Average.svelte";
    import BotLog from "./BotLog.svelte";
    import ScoreChart from './ScoreChart.svelte';
    import { convert } from "./ui.js";
    import { res } from './stores.js';
    import { allTokenTypes } from "./card_actions";
    import { ensureGameDetails } from "./net";
    export let capFunc;
    export let games;
    export let bot; 
    let captains;

    // <details> renders its children whether or not it is open, so without these
    // guards opening the Summary tab builds a Chart.js chart per captain over the
    // whole archive up front. Built on first open instead, and kept once built.
    let opened = {};
    let botOpened = {};

    $: if(games){
        let botToggle = 'no bot';
        if(bot) botToggle = 'bot';
        captains = capFunc(games, botToggle, bot);
    }

    function percentWins(c){ 
        return c.wins / c.played * 100;
    }

    function burnRate(c){
        return (c.burns || 0) / c.played * 100;
    }
</script>

<table>
    <tr>
        <td>Captain</td><td>Games played</td><td>Average turns</td><td>Win rate</td><td>Wins</td><td>Losses</td><td>Draws</td><td>% Burns</td><td>Average score</td><td>Average deck-size</td><td>Tokens and tracks</td>
        {#each ['ally', 'person', 'cargo', 'ship', 'encounter', 'incident'].sort() as k, i}
            <td>{@html k == 'redshirt' ? k : convert(`[[${k}]]`, true)}</td>
        {/each}
    </tr>
    {#each captains.sort((a,b) => percentWins(b) - percentWins(a)) as c}
        <tr class={c.name.toLowerCase()} style="color: white;">
            <td>{c.name}</td><td>{c.played}</td><td><Average data={c.turns} /></td><td>{Math.round(c.wins / c.played * 100)}%</td><td>{c.wins}</td><td>{c.losses}</td><td>{c.draws}</td><td>{Math.round(burnRate(c))}%</td><td><Average data={c.score} /></td><td><Average data={c.decksize} /></td>
                <td>
                    {#each [...allTokenTypes(), ...$res.trackTypes, 'collective'] as t, i}
                        <Average data={c[t]} digits=1 /> {@html convert(`[[${t}]]`)}
                        {#if i < [...allTokenTypes(), ...$res.trackTypes, 'collective'].length - 1}, &nbsp;{/if}
                    {/each}
                </td>
                {#each  ['ally', 'person', 'cargo', 'ship', 'encounter', 'incident'].sort() as k, i}
                    <td><Average data={c.gained[k]} digits=1 /></td>     
                {/each}
                
        </tr>
    {/each}
</table>
Score charts:
{#each captains as c}
    <details on:toggle={e => {if(e.target.open) opened[c.name] = true}}>
        <summary>{c.name}</summary>
        {#if opened[c.name]}
            <!-- per-turn series are fetched on demand for games listed from PocketBase -->
            {#await ensureGameDetails(games)}
                Loading turn data...
            {:then}
                <ScoreChart game={games} captain={c.name} bot={bot ? true : false} />
            {:catch e}
                Couldn't load turn data ({e.message}). <button on:click={() => {games = games;}}>Retry</button>
            {/await}
        {/if}
    </details>
{/each}
{#if bot}
    Bot chart statistics:
    {#each captains as c}
        <details on:toggle={e => {if(e.target.open) botOpened[c.name] = true}}>
            <summary>{c.name}</summary>
            {#if botOpened[c.name]}
                <BotLog {games} captain={c.name} />
            {/if}
        </details>
    {/each}
{/if}

<style>
 table {
        border: 1px solid white;
    }

    th {
        border-bottom: 1px solid white;
    }

    .center {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    .table_label {
        display: flex;
        flex-direction: column;
        align-items: center;
        align-content: center;

    }
    
    .player {
        border: 0.5vmin solid white;
        padding: 1vmin;
        margin-top: 1vmin;
        margin-bottom: 1vmin;
    }

    .picard {
        background-color: darkblue;
    }
    
    .koloth {
        background-color: darkred;
    }

    .sassanids {
        background-color: darkgoldenrod;
    }

    .cultists {
        background-color: red;
    }

    .zet {
        background-color: aqua;
    }
    
    .wookies {
        background-color: brown;
        color: white;
    }
    
    
    .sisko {
        background-color: #7393B3;
    }

    .shran {
        background-color: darkcyan;
    }

    .sela {
        background-color: darkgreen;
    }

    .kirk {
        background-color: darkgoldenrod;
    }

    .rebner {
        background-color: plum;
        color: black;
    }

    .freeman {
        background-color: purple;
    }

    .player_title {
        font-weight: bold;
        font-size: 2.5vmin; 
        /*text-decoration: underline;*/
    }

    .title {
        font-weight: bold;
        font-size: 3vmin;
        text-decoration: underline;
        margin-bottom: 1vmin;
    }

    .subtitle {
        font-style: italic;
        font-size: 2vmin;
    }

    .basicinfo {
        font-style: italic;
    }

    .line {
        margin-top: 0.5vmin;
        margin-bottom: 0.5vmin;
        width: 100%;
        height: 2px;
        background-color: white;
    }

    table, th, td {
        border: 1px solid white;
        border-collapse: collapse;
        text-align: center;
    }

    .score_item {
        margin-left: 20px;
    }

    .modal {
		position: absolute;
		z-index: 200;
		/*left: 50%;
		top: 50%;*/
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
		padding: 3vmin;
		padding-bottom: 1vmin;
		/*transform: translate(-50%, -50%);*/
		max-height: 90vh;
        height: fit-content;
        width: fit-content;
		max-width: 90vw;
		min-width: 60vw;
		overflow: auto;
		background-color: grey;
		color: black;
		box-shadow: 0 0 5px 5px black; color: white;
	}
</style>